<div class="grid">
  <div class="lg:col-7 col-12">
    <p-card>
      <div class="p-fluid">
        <div class="field">
          <label class="font-medium required-field">Название</label>
          <crm-input-text
            [(value)]="deal.name"
            [isError]="$any(errors?.name)"></crm-input-text>
          <small
            *ngIf="errors?.name"
            class="p-error">
            {{ errors.name | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium required-field">Контрагент</label>
          <crm-contragent-auto-complete
            [withClients]="true"
            [(selectedContragent)]="deal.contragent"
            (selectedContragentChange)="changeContragent()"
            [customSearch]="false"
            [isError]="$any(errors?.contragent)"
            appendTo="body"></crm-contragent-auto-complete>
          <small
            *ngIf="errors?.contragent"
            class="p-error">
            {{ errors.contragent | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Компания</label>
          <crm-company-single-select
            [(selectedCompany)]="deal.company"
            [styleClass]="errors?.company ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.company ? 'ng-invalid ng-dirty' : ''"
            [showClear]="true"
            appendTo="body">
          </crm-company-single-select>
          <small
            *ngIf="errors?.company"
            class="p-error">
            {{ errors.company | join }}
          </small>
        </div>

        @if (accessService.finance.dealRights.canReadDealType) {
          <div class="field">
            <label class="font-medium">Тип сделки</label>
            <crm-single-select
              [options]="dealTypes"
              [(selectedItem)]="deal.dealType"
              (selectedItemChange)="onDealTypeChange($event)"
              [showClear]="true"
              appendTo="body">
            </crm-single-select>
            <small
              *ngIf="errors?.dealType"
              class="p-error">
              {{ errors.dealType | join }}
            </small>
          </div>
        }

        <div class="field">
          <label class="font-medium">Договор</label>
          <crm-contract-single-select
            [(selectedEntity)]="deal.contract"
            [isError]="$any(errors?.contract)"
            [companyIds]="deal.company ? [deal.company?.id] : []"
            [contragentIds]="deal.contragent ? [deal.contragent?.id] : []"
            [showClear]="true"
            appendTo="body">
          </crm-contract-single-select>
          <small
            *ngIf="errors?.contract"
            class="p-error">
            {{ errors.contract | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Дата отгрузки</label>
          <crm-datepicker
            [(value)]="deal.shippingDate"
            [inputStyleClass]="errors?.shippingDate ? 'ng-invalid ng-dirty' : ''"
            appendTo="body"></crm-datepicker>
          <small
            *ngIf="errors?.shippingDate"
            class="p-error">
            {{ errors.shippingDate | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Описание</label>
          <crm-editor
            [(value)]="deal.comment"
            height="110px"></crm-editor>
          <small
            *ngIf="errors?.comment"
            class="p-error">
            {{ errors.comment | join }}
          </small>
        </div>

        @if (!canDelete) {
          <div class="field">
            <label class="font-medium">Файлы</label>
            @if (deal.files?.length) {
              <div class="mb-2">
                <crm-files-list
                  [files]="deal.files"
                  [canDelete]="true"
                  (deleteFile)="deleteFile(deal.files, $event)"></crm-files-list>
              </div>
            }

            <p-fileUpload
              #fileUpload
              mode="basic"
              [customUpload]="true"
              chooseIcon="pi-paperclip"
              chooseLabel="Прикрепить файл"
              [disabled]="filesLoading"
              (uploadHandler)="uploadFiles($event)"
              [auto]="true">
            </p-fileUpload>
            <small
              *ngIf="errors?.files"
              class="p-error">
              {{ errors.files | join }}
            </small>
          </div>
        }
      </div>
    </p-card>

    <div class="mt-3">
      <crm-deal-order-form
        [(orders)]="deal.orders"
        [errors]="errors?.orders"></crm-deal-order-form>
    </div>

    @if (accessService.finance.dealRights.isRentalRatesTabEnabled && this.deal?.dealType?.isRentDefault) {
      <div class="mt-3">
        <crm-deal-rent-form
          [deal]="deal"
          [errors]="errors"></crm-deal-rent-form>
      </div>
    }
  </div>

  <div class="lg:col-5 col-12">
    <p-card header="Дополнительные реквизиты">
      <div class="p-fluid">
        <div class="field">
          <label class="font-medium">Время план</label>
          <p-inputNumber
            [(ngModel)]="deal.plannedMin"
            [ngClass]="{ 'ng-invalid ng-dirty': errors?.plannedMin }"></p-inputNumber>
          <small
            *ngIf="errors?.plannedMin"
            class="p-error">
            {{ errors.plannedMin | join }}
          </small>
        </div>

        <div class="field">
          <label
            class="font-medium"
            [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.directionsRequired">
            Бюджетная статья
          </label>
          <crm-direction-single-select
            [directions]="directions"
            [(selectedDirection)]="deal.direction"
            [groupsDisabled]="true"
            [styleClass]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
            appendTo="body">
          </crm-direction-single-select>
          <small
            *ngIf="errors?.direction"
            class="p-error">
            {{ errors.direction | join }}
          </small>
        </div>

        <div class="field">
          <label
            class="font-medium"
            [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.unitsRequired">
            Бизнес единица
          </label>
          <crm-unit-single-select
            [(selectedUnit)]="deal.unit"
            [isError]="$any(errors?.unit)"
            [showClear]="true"
            appendTo="body"></crm-unit-single-select>
          <small
            *ngIf="errors?.unit"
            class="p-error">
            {{ errors.unit | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Проект</label>
          <crm-single-select
            [options]="groups"
            [(selectedItem)]="deal.group"
            [showClear]="true"
            [class]="errors?.group ? 'ng-invalid ng-dirty' : ''"
            appendTo="body"></crm-single-select>
          <small
            *ngIf="errors?.group"
            class="p-error">
            {{ errors.group | join }}
          </small>
        </div>

        <div class="field">
          <label
            class="font-medium"
            [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.filialsRequired">
            Филиал
          </label>
          <crm-filial-single-select
            [(selectedFilial)]="deal.filial"
            [isError]="$any(errors?.filial)"
            appendTo="body"
            [showClear]="true"></crm-filial-single-select>
          <small
            *ngIf="errors?.filial"
            class="p-error">
            {{ errors.filial | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Приоритет</label>
          <crm-priority-single-select
            [(selectedPriority)]="deal.priority"
            [styleClass]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
            appendTo="body">
          </crm-priority-single-select>
          <small
            *ngIf="errors?.priority"
            class="p-error">
            {{ errors.priority | join }}
          </small>
        </div>
      </div>
    </p-card>

    @if (deal.dealType?.eavEntityType?.attributes?.length) {
      <p-card
        [header]="deal.dealType?.eavEntityType?.name"
        styleClass="mt-3">
        <div class="p-fluid">
          @for (attribute of deal.dealType.eavEntityType.attributes | orderBy: 'id:number'; track attribute.id) {
            <ng-container [ngSwitch]="attribute.type">
              <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.FILIAL">
                <div class="field">
                  <label class="font-medium">
                    {{ attribute.name }}
                  </label>
                  @if (attribute.multipleSelect) {
                    <crm-filial-multi-select
                      [(selectedFilials)]="deal.eavEntity.values[attribute.id]"
                      [isFloatLabel]="false"
                      [showClear]="true"
                      appendTo="body"></crm-filial-multi-select>
                  } @else {
                    <crm-filial-single-select
                      [(selectedFilial)]="deal.eavEntity.values[attribute.id]"
                      [showClear]="true"
                      appendTo="body"></crm-filial-single-select>
                  }
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.COST_CENTER">
                <div class="field">
                  <label class="font-medium">
                    {{ attribute.name }}
                  </label>
                  @if (attribute.multipleSelect) {
                    <crm-cost-center-multi-select
                      [(selectedCostCenters)]="deal.eavEntity.values[attribute.id]"
                      [showClear]="true"
                      appendTo="body"></crm-cost-center-multi-select>
                  } @else {
                    <crm-cost-center-single-select
                      [(selectedCostCenter)]="deal.eavEntity.values[attribute.id]"
                      [showClear]="true"
                      appendTo="body"></crm-cost-center-single-select>
                  }
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.ROOM">
                <div class="field">
                  <label class="font-medium">
                    {{ attribute.name }}
                  </label>
                  @if (attribute.multipleSelect) {
                    <crm-room-multi-select
                      [(selectedRooms)]="deal.eavEntity.values[attribute.id]"
                      [showClear]="true"
                      [isFloatLabel]="false"
                      appendTo="body"></crm-room-multi-select>
                  } @else {
                    <crm-room-single-select
                      [(selectedRoom)]="deal.eavEntity.values[attribute.id]"
                      [showClear]="true"
                      appendTo="body"></crm-room-single-select>
                  }
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.TEXT">
                <div class="field">
                  <label class="font-medium">
                    {{ attribute.name }}
                  </label>
                  <crm-input-text
                    [(value)]="deal.eavEntity.values[attribute.id]"
                    class="w-full"></crm-input-text>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.NUMBER">
                <div class="field">
                  <label class="font-medium">
                    {{ attribute.name }}
                  </label>
                  <p-inputNumber [(ngModel)]="deal.eavEntity.values[attribute.id]"></p-inputNumber>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.BOOLEAN">
                <div class="field-checkbox">
                  <p-checkbox
                    [(ngModel)]="deal.eavEntity.values[attribute.id]"
                    [binary]="true"
                    [inputId]="attribute.id.toString()"></p-checkbox>
                  <label [for]="attribute.id.toString()">{{ attribute.name }}</label>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.DATE">
                <div class="field">
                  <label class="font-medium">
                    {{ attribute.name }}
                  </label>
                  <crm-datepicker
                    [(value)]="deal.eavEntity.values[attribute.id]"
                    appendTo="body"></crm-datepicker>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.TIMESTAMP">
                <div class="field">
                  <label class="font-medium">
                    {{ attribute.name }}
                  </label>
                  <crm-datepicker
                    [(value)]="deal.eavEntity.values[attribute.id]"
                    [showTime]="true"
                    [stepMinute]="15"
                    appendTo="body"></crm-datepicker>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.DATE_PERIOD">
                <div class="field">
                  <label class="font-medium">
                    {{ attribute.name }}
                  </label>
                  <crm-daterangepicker
                    [value]="[deal.eavEntity.values[attribute.id]?.from, deal.eavEntity.values[attribute.id]?.to]"
                    (changeValue)="
                      deal.eavEntity.values[attribute.id] = {
                        from: $event[0],
                        to: $event[1]
                      }
                    "
                    appendTo="body"></crm-daterangepicker>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.COMPUTED">
                <div class="field">
                  <label class="font-medium">
                    {{ attribute.name + ' (вычисляется автоматически)' }}
                  </label>
                  <p-inputNumber
                    [disabled]="true"
                    [(ngModel)]="deal.eavEntity.values[attribute.id]"></p-inputNumber>
                  @if (attribute.expression) {
                    <small class="text-color-secondary">
                      {{ attribute.expression | eavComputedExpression: deal.dealType?.eavEntityType?.tokens }}
                    </small>
                  }
                </div>
              </ng-container>
            </ng-container>

            @if (errors?.eavEntity?.values?.[attribute.id]) {
              <small class="p-error">
                {{ errors.eavEntity.values[attribute.id] | join }}
              </small>
            }
          }
        </div>
      </p-card>
    }

    <p-card
      *ngIf="accessService.project.projectRights.canReadProject"
      header="Задача"
      styleClass="mt-3">
      <div class="p-fluid">
        <div class="field">
          <label class="font-medium">Задача</label>
          <crm-project-multi-select
            [projects]="projects"
            [(selectedProjects)]="deal.projects"
            [isError]="$any(errors?.projects)"
            appendTo="body">
          </crm-project-multi-select>
          <p
            *ngIf="errors?.projects"
            class="p-error">
            {{ errors.projects | join }}
          </p>
        </div>
      </div>
    </p-card>

    <p-card
      *ngIf="accessService.helpdesk.helpdeskRights.canReadHelpdesk"
      header="Заявка HD"
      styleClass="mt-3">
      <div class="p-fluid">
        <div class="field">
          <label class="font-medium">Заявка HelpDesk</label>
          <crm-hd-task-multi-select
            [tasks]="tasks"
            [(selectedTasks)]="deal.helpdeskTasks"
            [isError]="$any(errors?.helpdeskTasks)"
            appendTo="body"></crm-hd-task-multi-select>
          <p
            *ngIf="errors?.helpdeskTasks"
            class="p-error">
            {{ errors.helpdeskTasks | join }}
          </p>
        </div>
      </div>
    </p-card>

    <p-card
      header="Участники"
      styleClass="mt-3">
      <div class="field">
        <label class="font-medium">Ответственный</label>
        <crm-user-single-select
          [(selectedUser)]="deal.responsible"
          [isError]="$any(errors?.responsible)"
          [showClear]="true"
          appendTo="body"></crm-user-single-select>
        <small
          *ngIf="errors?.responsible"
          class="p-error">
          {{ errors.responsible | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium">Внешний пользователь</label>
        <div class="flex align-items-center gap-1">
          <div class="flex-grow-1">
            <crm-external-user-single-select
              #externalUserSingleSelectComponent
              [(selectedEntity)]="deal.externalUser"
              [contragentIds]="deal.contragent?.id ? [deal.contragent.id] : null"
              [requireFilter]="true"
              [isError]="$any(errors?.externalUser)"
              [showClear]="true"
              [disabled]="!deal.contragent?.id"
              appendTo="body"></crm-external-user-single-select>
          </div>

          @if (deal.contragent?.id) {
            <crm-button
              icon="pi pi-plus"
              (onClick)="openFormCreateExternalUser()"></crm-button>
          }
        </div>
        @if (errors?.externalUser) {
          <small class="p-error">
            {{ errors.externalUser | join }}
          </small>
        }
      </div>

      <h3 class="font-medium -mb-2">Аудиторы</h3>
      <p-divider></p-divider>

      <div class="formgrid grid">
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Пользователи</label>
          <crm-user-multi-select
            [(selectedUsers)]="deal.userAuditors"
            [isError]="$any(errors?.userAuditors)"
            [isFloatLabel]="false"
            appendTo="body"></crm-user-multi-select>
          <p
            *ngIf="errors?.userAuditors"
            class="p-error">
            {{ errors.userAuditors | join }}
          </p>
        </div>

        <div class="field lg:col-6 col-12">
          <label class="font-medium">Группы</label>
          <crm-user-group-multi-select
            [(selectedUserGroups)]="deal.groupAuditors"
            [isFloatLabel]="false"
            appendTo="body"
            [class]="errors?.groupAuditors ? 'ng-invalid ng-dirty' : ''"
            [styleClass]="errors?.groupAuditors ? 'ng-invalid ng-dirty' : ''">
          </crm-user-group-multi-select>
          <p
            *ngIf="errors?.groupAuditors"
            class="p-error">
            {{ errors.groupAuditors | join }}
          </p>
        </div>
      </div>
    </p-card>
  </div>
</div>

<div class="grid mt-3">
  <div class="lg:col-7 col-12 flex flex-wrap justify-content-between">
    <div>
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success mr-2"
        (onClick)="onSave(deal)"></crm-button>
      <crm-go-back-button
        *ngIf="!isModal"
        [route]="route"></crm-go-back-button>
    </div>
    <crm-button
      *ngIf="canDelete"
      label="Удалить"
      styleClass="p-button-danger p-button-text"
      (onClick)="delete.emit(deal)"></crm-button>
  </div>
</div>
